import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter, Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from "@angular/core";
import {SiteFiltersType} from "../../../../commons/types/site-filters.type";
import {VisitPlanModel} from "../../../models/visit-plan.model";
import {PANEL_DATA} from "../../../../commons/angular/services/panel.service";
import {isNull, isUndefined} from "lodash";

interface VisitPlanJobsPanelFiltersDialogModel {
  visitPlan: VisitPlanModel;
  filters: any;
}

require('./visit-plan-jobs-panel-filters-dialog.scss');
@Component({
  standalone: false,
  selector: 'app-visit-plan-jobs-filters-dialog',
  templateUrl: './visit-plan-jobs-panel-filters-dialog.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VisitPlanJobsPanelFiltersDialogComponent implements OnInit {


  @Output() onClose = new EventEmitter<any>();

  filters: any;
  filtersCopy: any;
  visitPlan: VisitPlanModel;

  public routedFilter: { label: string, value: any };
  public inRouteOptions = [
    {
      label: 'Routed',
      value: true
    },
    {
      label: 'Leftover',
      value: false
    },
    {
      label: 'All',
      value: undefined
    }
  ];

  constructor(@Inject(PANEL_DATA) public data: VisitPlanJobsPanelFiltersDialogModel,) {
  }

  ngOnInit() {
    this.visitPlan = this.data.visitPlan;
    this.filters = JSON.parse(JSON.stringify(this.data.filters))
    this.filtersCopy = JSON.parse(JSON.stringify(this.data.filters));

    if (isUndefined(this.filters.inRoute)) {
      this.routedFilter = {
        label: 'All',
        value: undefined
      }
    } else {
      this.routedFilter = this.filters.inRoute ? {
        label: 'Routed',
        value: true
      } : {
        label: 'Leftover',
        value: false
      };
    }
  }

  onDemandAccountsSelect(selectedIds: string[]) {
    this.filtersCopy.accountIds = selectedIds;
  }

  onBranchesSelect(selectedIds: string[]) {
    this.filtersCopy.branchIds = selectedIds;
  }

  onChangeRoutedFilter(value: boolean | null) {
    if (isNull(value)) {
      this.routedFilter = {
        label: 'All',
        value: undefined
      }
      this.filtersCopy.inRoute = undefined;
    } else {
      this.routedFilter = value ? {
        label: 'Routed',
        value: true
      } : {
        label: 'Leftover',
        value: false
      };
      this.filtersCopy.inRoute = value;
    }
  }

  onSubmit() {
    this.onClose.emit(this.filtersCopy);
  }

  onReset() {
    const filters = {
      [SiteFiltersType.branchIds]: [],
      [SiteFiltersType.accountIds]: [],
      [SiteFiltersType.inRoute]: undefined
    }

    this.onClose.emit(filters);
  }

  onCancel() {
    this.onClose.emit(this.filters);
  }


}
